import { render } from "./MatchingIssueIcon.vue?vue&type=template&id=70e3b525"
import script from "./MatchingIssueIcon.vue?vue&type=script&lang=js"
export * from "./MatchingIssueIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Icons/MatchingIssueIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70e3b525"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70e3b525', __exports__)) {
    console.log('reload')
    api.reload('70e3b525', __exports__)
  }
  
  module.hot.accept("./MatchingIssueIcon.vue?vue&type=template&id=70e3b525", () => {
    console.log('re-render')
    api.rerender('70e3b525', render)
  })

}


export default __exports__